// features/notifications/notificationSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  getNotificationsByUser,
  markAsSeen,
} from "../thunks/notificationThunks";

const initialState = {
  notifications: [],
  loading: false,
  error: null,
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationsByUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotificationsByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
        state.unreadCount = action.payload.filter(
          (n) => new Date(n.seen_date_time) <= new Date("0001-01-02")
        ).length;
      })
      .addCase(getNotificationsByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(markAsSeen.fulfilled, (state, action) => {
        const updatedNotification = action.payload;
        state.notifications = state.notifications.map((notification) =>
          notification.notificationId === updatedNotification.notificationId
            ? updatedNotification
            : notification
        );
        state.unreadCount = state.notifications.filter(
          (n) => new Date(n.seen_date_time) <= new Date("0001-01-02")
        ).length;
      });
  },
});

export const { clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
